import Grid2 from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";


const FullWidthLine = ({ color = 'primary', height = 2, marginY = 0 }) => {
    const theme = useTheme();

    // Get the appropriate color from theme
    const lineColor =
        color === 'primary'
            ? theme.palette.primary.main
            : theme.palette.secondary.main;

    return (
        <Grid2 size={12}>
            <div
                style={{
                    width: '100%',
                    height: height,
                    backgroundColor: lineColor,
                    marginTop: theme.spacing(marginY),
                    marginBottom: theme.spacing(marginY),
                }}
            />
        </Grid2>
    );
};

export default FullWidthLine;
